<span *ngIf="!isFromAppSettings" class="fixed-top fixed_top_0">
    <div class="login_header header-fix " [ngClass]="'bg-'+globals.colorTheme">
        <a class="text-white container" routerLink="/booking">
            <span style="font-size: 30pt;">
               <strong> AGRIS Sales</strong>
            </span>
        </a>
    </div>
</span>
<br>
<br>
<br>
<br>
<br>
<br>
<br>
<mat-card class="login-box" >
<br>
<div class="row">
    <div class="col">
        <div id="topContainer">
            <div class="p-2 header_medium  text-center">
                <h3 *ngIf="!isFromAppSettings" class="text_green">AGRIS Log In</h3>
            </div>
        </div>
    </div>
</div>
<div class="row">
    <div class="col">
        <div class="container-fluid">
            <mat-form-field class="w-100">
                <mat-label for="loginid">AGRIS ID</mat-label>
                <input placeholder="Ex: IVG or 345" class="ta-login-username" #loginId matInput name="loginid" [(ngModel)]="model.loginid" uppercase
                    data-hj-whitelist />
                    <!-- <mat-hint>AGRIS Id is case sensitive</mat-hint> -->
            </mat-form-field>
            <br>
            <mat-form-field class="w-100">
                <mat-label for="password">AGRIS Password</mat-label>
                <input matInput class="ta-login-password" type="password" name="password"  [type]="hide ? 'password' : 'text'"
                    [(ngModel)]="model.password" />
                <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                <mat-hint>Password is case sensitive</mat-hint>
            </mat-form-field>
            <br><br>
            <button  mat-stroked-button  [disabled]="!model.loginid || !model.password"
                [ngClass]="'ta-login-login w-100 text-white btn btn-'+globals.colorTheme"
                (click)="login()">Log In</button>
            <br>
          
            <div class="pt-6"></div>
        </div>
    </div>
</div></mat-card>
  <div class="magin_5 text-center" *ngIf="!isFromAppSettings">
    <!-- <strong class="magin_5 font_16 left_26">{{selectedDataset}}</strong> -->
    <a class="ta-login-changedataset text-white magin_5" routerLink="/appsettings">Change
        Dataset</a>
</div>
